import React, { useState, useEffect } from 'react'
import ZenkliukoIkona from '../components/ZenkliukoIkona'
import { getAplankytos } from '../utils/aplankytos'
import { getPrisiminimai } from '../utils/prisiminimai'
import { skaiciuotiStatus, getZenkliukai, skaiciuotiTaskus, skaiciuotiLygi } from '../utils/statai'

function ZenkliukaiEkranas({ atidaryta, onClose, visosVietos }) {
  const [tab, setTab] = useState('turi')
  const [aplankytos, setAplankytos] = useState([])
  const [prisiminimai, setPrisiminimai] = useState([])

  useEffect(() => {
    if (atidaryta) { setAplankytos(getAplankytos()); setPrisiminimai(getPrisiminimai()); setTab('turi') }
  }, [atidaryta])

  const statai = skaiciuotiStatus(aplankytos, visosVietos, prisiminimai)
  const zenkliukai = getZenkliukai(statai)
  const uzdirbti = zenkliukai.filter(z => z.uzdirbtas)
  const galima = zenkliukai.filter(z => !z.uzdirbtas)
  const taskai = statai ? skaiciuotiTaskus(statai, uzdirbti.length) : 0
  const lygis = skaiciuotiLygi(taskai)

  const rodomi = tab === 'turi' ? uzdirbti : galima

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1002, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 340ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 8px' }}>
        <button onClick={onClose} aria-label="Atgal" style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid #3A4C42', background: 'transparent', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <span style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 19 }}>Ženkliukai</span>
        <div style={{ width: 34 }} />
      </div>

      {/* Exp bar */}
      <div style={{ padding: '8px 20px 16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
          <span style={{ color: '#E5A840', fontFamily: "'Lora', Georgia, serif", fontSize: 18 }}>Lygis {lygis.lygis}</span>
          <span style={{ color: '#7A8A7E', fontSize: 12 }}>{lygis.kitas != null ? `${lygis.iki} taškų iki ${lygis.lygis + 1} lygio` : 'Aukščiausias lygis'}</span>
        </div>
        <div style={{ height: 6, background: '#2A3B32', borderRadius: 3, overflow: 'hidden' }}>
          <div style={{ width: `${lygis.proc}%`, height: '100%', background: '#E5A840', transition: 'width 0.4s ease' }} />
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', padding: '0 20px', borderBottom: '1px solid #2A3B32' }}>
        <div onClick={() => setTab('turi')} style={{ flex: 1, textAlign: 'center', paddingBottom: 8, fontSize: 13, cursor: 'pointer', color: tab === 'turi' ? '#F0E8D5' : '#7A8A7E', borderBottom: `2px solid ${tab === 'turi' ? '#E5A840' : 'transparent'}` }}>Turi · {uzdirbti.length}</div>
        <div onClick={() => setTab('galima')} style={{ flex: 1, textAlign: 'center', paddingBottom: 8, fontSize: 13, cursor: 'pointer', color: tab === 'galima' ? '#F0E8D5' : '#7A8A7E', borderBottom: `2px solid ${tab === 'galima' ? '#E5A840' : 'transparent'}` }}>Galima gauti · {galima.length}</div>
      </div>

      {/* Grid */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '18px 16px 28px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '18px 10px', alignContent: 'start' }}>
        {rodomi.length === 0 ? (
          <p style={{ gridColumn: '1 / -1', color: '#7A8A7E', fontSize: 13, textAlign: 'center', padding: '24px 0' }}>
            {tab === 'turi' ? 'Dar neuždirbai nė vieno — keliauk ir žymėk „Buvau čia"' : 'Visi ženkliukai jau tavo! 🌲'}
          </p>
        ) : rodomi.map(z => (
          <div key={z.id} style={{ textAlign: 'center', opacity: z.uzdirbtas ? 1 : 0.6 }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', background: z.uzdirbtas ? 'rgba(229,168,64,0.16)' : '#1E2E27', border: `2px ${z.uzdirbtas ? 'solid #E5A840' : 'dashed #3A4C42'}` }}>
              <ZenkliukoIkona ikona={z.ikona} dydis={26} spalva={z.uzdirbtas ? '#E5A840' : '#7A8A7E'} />
            </div>
            <div style={{ color: '#B0B8A8', fontSize: 9, marginTop: 5, lineHeight: 1.25 }}>{z.pavadinimas}</div>
            {!z.uzdirbtas && <div style={{ color: '#5A6558', fontSize: 9, marginTop: 2 }}>{z.esamas}/{z.tikslas}</div>}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ZenkliukaiEkranas
